import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Sync", -1)
const _hoisted_2 = {
  key: 0,
  class: "nav-main-routes__sync-counter"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Goals", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Directory", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Board", -1)

import { computed, ref } from 'vue'
import { useStore } from '@/store'
import { DateTime } from 'luxon'

import { Membership } from '@/types/membership'
import { User } from '@/types/user'
import DailySync from '@/types/dailySync'

import { flatten } from '@/utils/commonUtils'
import { getDailySyncForUser } from '@/utils/dailySyncUtils'

import AppCustomTooltip from '@common/AppCustomTooltip.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  minimized: Boolean
},
  setup(__props) {

const props = __props



const store = useStore()
const dayBeingViewedOffset = ref(0)
const user = computed<User>(() => store.getters['user/getUser'])
const teamMemberships = computed<Membership[]>(() => store.getters['teams/getActiveTeamMembers'])
const dayBeingViewed = computed<string>(() => DateTime.now().plus({ days: dayBeingViewedOffset.value }).toISODate())

function getSortedSyncsForTeamMembers() {
  const members = teamMemberships.value.filter(e => e.userId !== user.value.userId)
  const syncs = flatten(members.map(e => getDailySyncForUser(DateTime.fromISO(dayBeingViewed.value), e.userId)))
  syncs.sort((a, b) => b.lastUpdatedAt.localeCompare(a.lastUpdatedAt))
  return syncs.map(e => ({
    sync: e,
    member: members.find(m => m.userId === e.userId)
  }))
}

const sortedTeamMemberSyncs = computed<{ sync: DailySync, member?: Membership }[]>(getSortedSyncsForTeamMembers)

const unseenSyncs = computed(() => {
  if (user.value.lastViewedSyncTime) {
    const lastViewedSyncTime = DateTime.fromISO(user.value.lastViewedSyncTime)
    return sortedTeamMemberSyncs.value.filter(e => DateTime.fromISO(e.sync.lastUpdatedAt) > lastViewedSyncTime).length
  } else {
    return sortedTeamMemberSyncs.value.length
  }
})

return (_ctx: any,_cache: any) => {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["nav-main-routes", { 'nav-main-routes--minimized': __props.minimized }]),
    "aria-label": "Main routes navigation"
  }, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createVNode(AppCustomTooltip, { title: "Sync" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createVNode(_component_AppIcon, {
                  name: "plays",
                  size: "19"
                }),
                _hoisted_1,
                (_unref(unseenSyncs) > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(unseenSyncs)), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(AppCustomTooltip, { title: "Goals" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: "/goals" }, {
              default: _withCtx(() => [
                _createVNode(_component_AppIcon, {
                  name: "flag",
                  size: "16"
                }),
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(AppCustomTooltip, { title: "Directory" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: "/team" }, {
              default: _withCtx(() => [
                _createVNode(_component_AppIcon, {
                  name: "insights",
                  size: "17"
                }),
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(AppCustomTooltip, { title: "Board" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: "/pulse" }, {
              default: _withCtx(() => [
                _createVNode(_component_AppIcon, {
                  name: "pulse",
                  size: "16"
                }),
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ], 2))
}
}

})